// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-container {
    width: 210mm;
    min-height: 297mm;
    padding: 10mm;
    margin: 0 auto;
    border: 1px solid #ccc;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    font-family: Cairo, sans-serif;
    transform-origin: top center;
    background-color: white;
}

.invoice-title {
    background-color: #f8f9fa;
    padding: 10px;
    border-radius: 5px;
    color: #333;
}

.zoomContainer {
    width: 100%;
    height: calc(100vh - 150px);
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 20px 0;
}

.toolbar {
    display: flex;
    background-color: #36a3f7;
    padding: 10px 20px;
    align-items: center;
    margin-bottom: 20px;
    border-radius: 8px;
    color: white;
    gap: 15px;
}

.toolbar-button {
    background: none;
    border: none;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 50%;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: rgba(255, 255, 255, 0.2);
    }

    .material-icons {
        font-size: 24px;
    }
}

.rotate-180 {
    transform: rotate(180deg);
}

.rotating {
    animation: rotate 2s linear infinite;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.table-header-invoice {
    background-color: #36a3f7 !important;
    color: white !important;

    th {
        color: white !important;
        font-weight: 700;
    }
}

.bg-gray-300i {
    background-color: #f1f3f5 !important;
}

.bg-gray-200i {
    background-color: #f8f9fa !important;
}

.min-w-80px {
    min-width: 120px;
}

.page-number {
    display: none;
}

/* تحسين عرض الجداول */
.table-bordered {
    border-collapse: collapse;
}

.table-bordered td,
.table-bordered th {
    border: 1px solid #dee2e6;
}

/* تحسين المسافات للعرض العادي */
.mb-3 {
    margin-bottom: 1rem;
}

.mt-3 {
    margin-top: 1rem;
}

@media print {

    /* تعيين حجم الصفحة والهوامش */
    @page {
        size: A4 portrait;
        margin: 10mm 12mm 15mm 12mm;
    }

    /* Force colors to print */
    * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        box-sizing: border-box !important;
    }

    html,
    body {
        width: 100% !important;
        height: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        background-color: white !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    /* إخفاء شريط الأدوات */
    .toolbar {
        display: none !important;
    }

    /* حاوية الفاتورة */
    .invoice-container {
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        border: none !important;
        box-shadow: none !important;
        transform: none !important;
        min-height: auto !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    /* حاوية التكبير */
    .zoomContainer {
        width: 100% !important;
        height: auto !important;
        overflow: visible !important;
        padding: 0 !important;
        margin: 0 !important;
    }

    /* صفحة الطباعة */
    .print-page {
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        border: none !important;
        page-break-after: auto !important;
    }

    /* جدول الطباعة - استخدام display: table لتكرار الهيدر والفوتر */
    .print-page-table {
        display: table !important;
        width: 100% !important;
        table-layout: fixed !important;
        border-collapse: collapse !important;
    }

    /* الهيدر - يتكرر في كل صفحة */
    .print-header {
        display: table-header-group !important;
        page-break-inside: avoid !important;
        page-break-after: avoid !important;
    }

    /* محتوى الصفحة */
    .print-body {
        display: table-row-group !important;
    }

    /* الفوتر - يتكرر في كل صفحة */
    .print-footer {
        display: table-footer-group !important;
        page-break-inside: avoid !important;
        page-break-before: avoid !important;
        border-top: 1px solid #ddd !important;
        padding-top: 8px !important;
    }

    .print-footer .row {
        display: flex !important;
        width: 100% !important;
        margin: 0 !important;
    }

    .print-footer .col-6 {
        width: 50% !important;
        padding: 0 5px !important;
    }

    /* تقليل حجم الخطوط للطباعة */
    .fs-6 {
        font-size: 11pt !important;
    }

    .fs-8 {
        font-size: 9pt !important;
    }

    .fs-9 {
        font-size: 8pt !important;
    }

    /* تقليل المسافات */
    .mb-5 {
        margin-bottom: 8px !important;
    }

    .mt-5 {
        margin-top: 8px !important;
    }

    .p-3 {
        padding: 6px !important;
    }

    /* تحسين الجداول */
    table {
        width: 100% !important;
        page-break-inside: auto !important;
        border-collapse: collapse !important;
    }

    thead {
        display: table-header-group !important;
    }

    tbody {
        display: table-row-group !important;
    }

    tr {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
    }

    td,
    th {
        padding: 4px 6px !important;
        font-size: 8pt !important;
        line-height: 1.3 !important;
    }

    /* Preserve table header colors */
    .table-header-invoice {
        background-color: #36a3f7 !important;
        color: white !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    .table-header-invoice th {
        background-color: #36a3f7 !important;
        color: white !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        padding: 6px !important;
        font-size: 9pt !important;
    }

    /* Preserve background colors */
    .bg-gray-300i {
        background-color: #f1f3f5 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    .bg-gray-200i {
        background-color: #f8f9fa !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    .invoice-title {
        background-color: #f8f9fa !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        padding: 6px !important;
        font-size: 12pt !important;
    }

    /* تحسين الباركود */
    ngx-barcode6 {
        max-height: 40px !important;
    }

    /* تحسين الحدود */
    .border-2 {
        border-width: 1px !important;
    }

    .border-gray-400 {
        border-color: #dee2e6 !important;
    }

    /* إخفاء عناصر غير ضرورية */
    .page-number-footer {
        display: none !important;
    }

    /* تحسين العرض للأعمدة */
    .col-6 {
        width: 50% !important;
        float: left !important;
        padding: 0 5px !important;
    }

    .col-12 {
        width: 100% !important;
        padding: 0 5px !important;
    }

    .row {
        display: flex !important;
        flex-wrap: wrap !important;
        margin: 0 -5px !important;
    }

    /* تحسين الـ badges */
    .badge {
        padding: 2px 6px !important;
        font-size: 7pt !important;
    }

    /* منع قطع العناصر المهمة */
    .title,
    .branch-header-repeat {
        page-break-inside: avoid !important;
    }

    /* تحسين table-responsive */
    .table-responsive {
        overflow: visible !important;
        width: 100% !important;
    }

    /* تقليل المسافات الداخلية */
    .body {
        padding: 4px !important;
    }
}
/* Export Mode (mimics print) for html2pdf */
.invoice-container.export-mode {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 10mm 12mm 15mm 12mm !important;
    border: none !important;
    box-shadow: none !important;
    transform: none !important;
    min-height: auto !important;
}
.invoice-container.export-mode .print-page {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
}
.invoice-container.export-mode .print-page-table {
    display: table !important;
    width: 100% !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
}
.invoice-container.export-mode .print-header { display: table-header-group !important; }
.invoice-container.export-mode .print-body { display: table-row-group !important; }
.invoice-container.export-mode .print-footer {
    display: table-footer-group !important;
    border-top: 1px solid #ddd !important;
    padding-top: 8px !important;
}
.invoice-container.export-mode .print-footer .row {
    display: flex !important;
    width: 100% !important;
    margin: 0 !important;
}
.invoice-container.export-mode .print-footer .col-6 {
    width: 50% !important;
    padding: 0 5px !important;
}
.invoice-container.export-mode .fs-6 { font-size: 11pt !important; }
.invoice-container.export-mode .fs-8 { font-size: 9pt !important; }
.invoice-container.export-mode .fs-9 { font-size: 8pt !important; }
.invoice-container.export-mode .mb-5 { margin-bottom: 8px !important; }
.invoice-container.export-mode .mt-5 { margin-top: 8px !important; }
.invoice-container.export-mode .p-3 { padding: 6px !important; }
.invoice-container.export-mode table {
    width: 100% !important;
    border-collapse: collapse !important;
}
.invoice-container.export-mode thead { display: table-header-group !important; }
.invoice-container.export-mode tbody { display: table-row-group !important; }
.invoice-container.export-mode td,
.invoice-container.export-mode th {
    padding: 4px 6px !important;
    font-size: 8pt !important;
    line-height: 1.3 !important;
}
.invoice-container.export-mode .table-header-invoice {
    background-color: #36a3f7 !important;
    color: white !important;
}
.invoice-container.export-mode .table-header-invoice th {
    background-color: #36a3f7 !important;
    color: white !important;
    padding: 6px !important;
    font-size: 9pt !important;
}
.invoice-container.export-mode .bg-gray-300i { background-color: #f1f3f5 !important; }
.invoice-container.export-mode .bg-gray-200i { background-color: #f8f9fa !important; }
.invoice-container.export-mode .invoice-title {
    background-color: #f8f9fa !important;
    padding: 6px !important;
    font-size: 12pt !important;
}
.invoice-container.export-mode ngx-barcode6 { max-height: 40px !important; }
.invoice-container.export-mode .border-2 { border-width: 1px !important; }
.invoice-container.export-mode .border-gray-400 { border-color: #dee2e6 !important; }
.invoice-container.export-mode .page-number-footer { display: none !important; }
.invoice-container.export-mode .col-6 {
    width: 50% !important;
    float: left !important;
    padding: 0 5px !important;
}
.invoice-container.export-mode .col-12 {
    width: 100% !important;
    padding: 0 5px !important;
}
.invoice-container.export-mode .row {
    display: flex !important;
    flex-wrap: wrap !important;
    margin: 0 -5px !important;
}
.invoice-container.export-mode .badge {
    padding: 2px 6px !important;
    font-size: 7pt !important;
}
.invoice-container.export-mode .table-responsive {
    overflow: visible !important;
    width: 100% !important;
}
.invoice-container.export-mode .body { padding: 4px !important; }

`, "",{"version":3,"sources":["webpack://./src/app/shared/components/print-export-document/print-export-document.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,uCAAuC;IACvC,8BAA8B;IAC9B,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;;IAEjC;QACI,0CAA0C;IAC9C;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;;IAEvB;QACI,uBAAuB;QACvB,gBAAgB;IACpB;AACJ;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA,gCAAgC;AAChC;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,8BAA8B;IAC9B;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA,0BAA0B;IAC1B;QACI,4CAA4C;QAC5C,oCAAoC;QACpC,iCAAiC;IACrC;;IAEA;;QAEI,sBAAsB;QACtB,uBAAuB;QACvB,oBAAoB;QACpB,qBAAqB;QACrB,kCAAkC;QAClC,4CAA4C;QAC5C,oCAAoC;IACxC;;IAEA,uBAAuB;IACvB;QACI,wBAAwB;IAC5B;;IAEA,mBAAmB;IACnB;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,oBAAoB;QACpB,qBAAqB;QACrB,uBAAuB;QACvB,2BAA2B;QAC3B,0BAA0B;QAC1B,2BAA2B;QAC3B,4CAA4C;QAC5C,oCAAoC;IACxC;;IAEA,kBAAkB;IAClB;QACI,sBAAsB;QACtB,uBAAuB;QACvB,4BAA4B;QAC5B,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA,iBAAiB;IACjB;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,oBAAoB;QACpB,qBAAqB;QACrB,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA,gEAAgE;IAChE;QACI,yBAAyB;QACzB,sBAAsB;QACtB,8BAA8B;QAC9B,oCAAoC;IACxC;;IAEA,8BAA8B;IAC9B;QACI,sCAAsC;QACtC,mCAAmC;QACnC,kCAAkC;IACtC;;IAEA,iBAAiB;IACjB;QACI,mCAAmC;IACvC;;IAEA,8BAA8B;IAC9B;QACI,sCAAsC;QACtC,mCAAmC;QACnC,mCAAmC;QACnC,qCAAqC;QACrC,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;QACxB,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,qBAAqB;QACrB,yBAAyB;IAC7B;;IAEA,6BAA6B;IAC7B;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA,mBAAmB;IACnB;QACI,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA,kBAAkB;IAClB;QACI,sBAAsB;QACtB,kCAAkC;QAClC,oCAAoC;IACxC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,mCAAmC;QACnC,iCAAiC;IACrC;;IAEA;;QAEI,2BAA2B;QAC3B,yBAAyB;QACzB,2BAA2B;IAC/B;;IAEA,iCAAiC;IACjC;QACI,oCAAoC;QACpC,uBAAuB;QACvB,4CAA4C;QAC5C,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;QACpC,uBAAuB;QACvB,4CAA4C;QAC5C,oCAAoC;QACpC,uBAAuB;QACvB,yBAAyB;IAC7B;;IAEA,+BAA+B;IAC/B;QACI,oCAAoC;QACpC,4CAA4C;QAC5C,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;QACpC,4CAA4C;QAC5C,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;QACpC,4CAA4C;QAC5C,oCAAoC;QACpC,uBAAuB;QACvB,0BAA0B;IAC9B;;IAEA,mBAAmB;IACnB;QACI,2BAA2B;IAC/B;;IAEA,iBAAiB;IACjB;QACI,4BAA4B;IAChC;;IAEA;QACI,gCAAgC;IACpC;;IAEA,2BAA2B;IAC3B;QACI,wBAAwB;IAC5B;;IAEA,wBAAwB;IACxB;QACI,qBAAqB;QACrB,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;QACxB,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA,qBAAqB;IACrB;QACI,2BAA2B;QAC3B,yBAAyB;IAC7B;;IAEA,2BAA2B;IAC3B;;QAEI,mCAAmC;IACvC;;IAEA,2BAA2B;IAC3B;QACI,4BAA4B;QAC5B,sBAAsB;IAC1B;;IAEA,4BAA4B;IAC5B;QACI,uBAAuB;IAC3B;AACJ;AACA,4CAA4C;AAC5C;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,uCAAuC;IACvC,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;IAC9B,oCAAoC;AACxC;AACA,+CAA+C,sCAAsC,EAAE;AACvF,6CAA6C,mCAAmC,EAAE;AAClF;IACI,sCAAsC;IACtC,qCAAqC;IACrC,2BAA2B;AAC/B;AACA;IACI,wBAAwB;IACxB,sBAAsB;IACtB,oBAAoB;AACxB;AACA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;AACA,uCAAuC,0BAA0B,EAAE;AACnE,uCAAuC,yBAAyB,EAAE;AAClE,uCAAuC,yBAAyB,EAAE;AAClE,uCAAuC,6BAA6B,EAAE;AACtE,uCAAuC,0BAA0B,EAAE;AACnE,sCAAsC,uBAAuB,EAAE;AAC/D;IACI,sBAAsB;IACtB,oCAAoC;AACxC;AACA,uCAAuC,sCAAsC,EAAE;AAC/E,uCAAuC,mCAAmC,EAAE;AAC5E;;IAEI,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;AAC/B;AACA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;AACA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;AAC7B;AACA,+CAA+C,oCAAoC,EAAE;AACrF,+CAA+C,oCAAoC,EAAE;AACrF;IACI,oCAAoC;IACpC,uBAAuB;IACvB,0BAA0B;AAC9B;AACA,8CAA8C,2BAA2B,EAAE;AAC3E,2CAA2C,4BAA4B,EAAE;AACzE,kDAAkD,gCAAgC,EAAE;AACpF,qDAAqD,wBAAwB,EAAE;AAC/E;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;AACA;IACI,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA,uCAAuC,uBAAuB,EAAE","sourcesContent":[".invoice-container {\n    width: 210mm;\n    min-height: 297mm;\n    padding: 10mm;\n    margin: 0 auto;\n    border: 1px solid #ccc;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    font-family: Cairo, sans-serif;\n    transform-origin: top center;\n    background-color: white;\n}\n\n.invoice-title {\n    background-color: #f8f9fa;\n    padding: 10px;\n    border-radius: 5px;\n    color: #333;\n}\n\n.zoomContainer {\n    width: 100%;\n    height: calc(100vh - 150px);\n    overflow: auto;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    padding: 20px 0;\n}\n\n.toolbar {\n    display: flex;\n    background-color: #36a3f7;\n    padding: 10px 20px;\n    align-items: center;\n    margin-bottom: 20px;\n    border-radius: 8px;\n    color: white;\n    gap: 15px;\n}\n\n.toolbar-button {\n    background: none;\n    border: none;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: background-color 0.2s;\n\n    &:hover {\n        background-color: rgba(255, 255, 255, 0.2);\n    }\n\n    .material-icons {\n        font-size: 24px;\n    }\n}\n\n.rotate-180 {\n    transform: rotate(180deg);\n}\n\n.rotating {\n    animation: rotate 2s linear infinite;\n}\n\n@keyframes rotate {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.table-header-invoice {\n    background-color: #36a3f7 !important;\n    color: white !important;\n\n    th {\n        color: white !important;\n        font-weight: 700;\n    }\n}\n\n.bg-gray-300i {\n    background-color: #f1f3f5 !important;\n}\n\n.bg-gray-200i {\n    background-color: #f8f9fa !important;\n}\n\n.min-w-80px {\n    min-width: 120px;\n}\n\n.page-number {\n    display: none;\n}\n\n/* تحسين عرض الجداول */\n.table-bordered {\n    border-collapse: collapse;\n}\n\n.table-bordered td,\n.table-bordered th {\n    border: 1px solid #dee2e6;\n}\n\n/* تحسين المسافات للعرض العادي */\n.mb-3 {\n    margin-bottom: 1rem;\n}\n\n.mt-3 {\n    margin-top: 1rem;\n}\n\n@media print {\n\n    /* تعيين حجم الصفحة والهوامش */\n    @page {\n        size: A4 portrait;\n        margin: 10mm 12mm 15mm 12mm;\n    }\n\n    /* Force colors to print */\n    * {\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n        box-sizing: border-box !important;\n    }\n\n    html,\n    body {\n        width: 100% !important;\n        height: 100% !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        background-color: white !important;\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n\n    /* إخفاء شريط الأدوات */\n    .toolbar {\n        display: none !important;\n    }\n\n    /* حاوية الفاتورة */\n    .invoice-container {\n        width: 100% !important;\n        max-width: 100% !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        border: none !important;\n        box-shadow: none !important;\n        transform: none !important;\n        min-height: auto !important;\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n\n    /* حاوية التكبير */\n    .zoomContainer {\n        width: 100% !important;\n        height: auto !important;\n        overflow: visible !important;\n        padding: 0 !important;\n        margin: 0 !important;\n    }\n\n    /* صفحة الطباعة */\n    .print-page {\n        width: 100% !important;\n        max-width: 100% !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        border: none !important;\n        page-break-after: auto !important;\n    }\n\n    /* جدول الطباعة - استخدام display: table لتكرار الهيدر والفوتر */\n    .print-page-table {\n        display: table !important;\n        width: 100% !important;\n        table-layout: fixed !important;\n        border-collapse: collapse !important;\n    }\n\n    /* الهيدر - يتكرر في كل صفحة */\n    .print-header {\n        display: table-header-group !important;\n        page-break-inside: avoid !important;\n        page-break-after: avoid !important;\n    }\n\n    /* محتوى الصفحة */\n    .print-body {\n        display: table-row-group !important;\n    }\n\n    /* الفوتر - يتكرر في كل صفحة */\n    .print-footer {\n        display: table-footer-group !important;\n        page-break-inside: avoid !important;\n        page-break-before: avoid !important;\n        border-top: 1px solid #ddd !important;\n        padding-top: 8px !important;\n    }\n\n    .print-footer .row {\n        display: flex !important;\n        width: 100% !important;\n        margin: 0 !important;\n    }\n\n    .print-footer .col-6 {\n        width: 50% !important;\n        padding: 0 5px !important;\n    }\n\n    /* تقليل حجم الخطوط للطباعة */\n    .fs-6 {\n        font-size: 11pt !important;\n    }\n\n    .fs-8 {\n        font-size: 9pt !important;\n    }\n\n    .fs-9 {\n        font-size: 8pt !important;\n    }\n\n    /* تقليل المسافات */\n    .mb-5 {\n        margin-bottom: 8px !important;\n    }\n\n    .mt-5 {\n        margin-top: 8px !important;\n    }\n\n    .p-3 {\n        padding: 6px !important;\n    }\n\n    /* تحسين الجداول */\n    table {\n        width: 100% !important;\n        page-break-inside: auto !important;\n        border-collapse: collapse !important;\n    }\n\n    thead {\n        display: table-header-group !important;\n    }\n\n    tbody {\n        display: table-row-group !important;\n    }\n\n    tr {\n        page-break-inside: avoid !important;\n        page-break-after: auto !important;\n    }\n\n    td,\n    th {\n        padding: 4px 6px !important;\n        font-size: 8pt !important;\n        line-height: 1.3 !important;\n    }\n\n    /* Preserve table header colors */\n    .table-header-invoice {\n        background-color: #36a3f7 !important;\n        color: white !important;\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n\n    .table-header-invoice th {\n        background-color: #36a3f7 !important;\n        color: white !important;\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n        padding: 6px !important;\n        font-size: 9pt !important;\n    }\n\n    /* Preserve background colors */\n    .bg-gray-300i {\n        background-color: #f1f3f5 !important;\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n\n    .bg-gray-200i {\n        background-color: #f8f9fa !important;\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n\n    .invoice-title {\n        background-color: #f8f9fa !important;\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n        padding: 6px !important;\n        font-size: 12pt !important;\n    }\n\n    /* تحسين الباركود */\n    ngx-barcode6 {\n        max-height: 40px !important;\n    }\n\n    /* تحسين الحدود */\n    .border-2 {\n        border-width: 1px !important;\n    }\n\n    .border-gray-400 {\n        border-color: #dee2e6 !important;\n    }\n\n    /* إخفاء عناصر غير ضرورية */\n    .page-number-footer {\n        display: none !important;\n    }\n\n    /* تحسين العرض للأعمدة */\n    .col-6 {\n        width: 50% !important;\n        float: left !important;\n        padding: 0 5px !important;\n    }\n\n    .col-12 {\n        width: 100% !important;\n        padding: 0 5px !important;\n    }\n\n    .row {\n        display: flex !important;\n        flex-wrap: wrap !important;\n        margin: 0 -5px !important;\n    }\n\n    /* تحسين الـ badges */\n    .badge {\n        padding: 2px 6px !important;\n        font-size: 7pt !important;\n    }\n\n    /* منع قطع العناصر المهمة */\n    .title,\n    .branch-header-repeat {\n        page-break-inside: avoid !important;\n    }\n\n    /* تحسين table-responsive */\n    .table-responsive {\n        overflow: visible !important;\n        width: 100% !important;\n    }\n\n    /* تقليل المسافات الداخلية */\n    .body {\n        padding: 4px !important;\n    }\n}\n/* Export Mode (mimics print) for html2pdf */\n.invoice-container.export-mode {\n    width: 100% !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n    padding: 10mm 12mm 15mm 12mm !important;\n    border: none !important;\n    box-shadow: none !important;\n    transform: none !important;\n    min-height: auto !important;\n}\n.invoice-container.export-mode .print-page {\n    width: 100% !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    border: none !important;\n}\n.invoice-container.export-mode .print-page-table {\n    display: table !important;\n    width: 100% !important;\n    table-layout: fixed !important;\n    border-collapse: collapse !important;\n}\n.invoice-container.export-mode .print-header { display: table-header-group !important; }\n.invoice-container.export-mode .print-body { display: table-row-group !important; }\n.invoice-container.export-mode .print-footer {\n    display: table-footer-group !important;\n    border-top: 1px solid #ddd !important;\n    padding-top: 8px !important;\n}\n.invoice-container.export-mode .print-footer .row {\n    display: flex !important;\n    width: 100% !important;\n    margin: 0 !important;\n}\n.invoice-container.export-mode .print-footer .col-6 {\n    width: 50% !important;\n    padding: 0 5px !important;\n}\n.invoice-container.export-mode .fs-6 { font-size: 11pt !important; }\n.invoice-container.export-mode .fs-8 { font-size: 9pt !important; }\n.invoice-container.export-mode .fs-9 { font-size: 8pt !important; }\n.invoice-container.export-mode .mb-5 { margin-bottom: 8px !important; }\n.invoice-container.export-mode .mt-5 { margin-top: 8px !important; }\n.invoice-container.export-mode .p-3 { padding: 6px !important; }\n.invoice-container.export-mode table {\n    width: 100% !important;\n    border-collapse: collapse !important;\n}\n.invoice-container.export-mode thead { display: table-header-group !important; }\n.invoice-container.export-mode tbody { display: table-row-group !important; }\n.invoice-container.export-mode td,\n.invoice-container.export-mode th {\n    padding: 4px 6px !important;\n    font-size: 8pt !important;\n    line-height: 1.3 !important;\n}\n.invoice-container.export-mode .table-header-invoice {\n    background-color: #36a3f7 !important;\n    color: white !important;\n}\n.invoice-container.export-mode .table-header-invoice th {\n    background-color: #36a3f7 !important;\n    color: white !important;\n    padding: 6px !important;\n    font-size: 9pt !important;\n}\n.invoice-container.export-mode .bg-gray-300i { background-color: #f1f3f5 !important; }\n.invoice-container.export-mode .bg-gray-200i { background-color: #f8f9fa !important; }\n.invoice-container.export-mode .invoice-title {\n    background-color: #f8f9fa !important;\n    padding: 6px !important;\n    font-size: 12pt !important;\n}\n.invoice-container.export-mode ngx-barcode6 { max-height: 40px !important; }\n.invoice-container.export-mode .border-2 { border-width: 1px !important; }\n.invoice-container.export-mode .border-gray-400 { border-color: #dee2e6 !important; }\n.invoice-container.export-mode .page-number-footer { display: none !important; }\n.invoice-container.export-mode .col-6 {\n    width: 50% !important;\n    float: left !important;\n    padding: 0 5px !important;\n}\n.invoice-container.export-mode .col-12 {\n    width: 100% !important;\n    padding: 0 5px !important;\n}\n.invoice-container.export-mode .row {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    margin: 0 -5px !important;\n}\n.invoice-container.export-mode .badge {\n    padding: 2px 6px !important;\n    font-size: 7pt !important;\n}\n.invoice-container.export-mode .table-responsive {\n    overflow: visible !important;\n    width: 100% !important;\n}\n.invoice-container.export-mode .body { padding: 4px !important; }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
